import React from 'react';
import { Box, Button } from '@mui/material';
import useCancelLicense from '../hooks/useCancelLicense';
import CancelSubscriptionDialog from './CancelSubscriptionDialog';

interface CancelSubscriptionButtonProps {
    subscriptionId: number;
    subscriptionName: string;
    onCancelled: () => void;
    onError: (message: string) => void;
}

export default function CancelSubscriptionButton({
    subscriptionId,
    subscriptionName,
    onCancelled,
    onError,
}: CancelSubscriptionButtonProps) {
    const {
        isCancelling,
        isConfirmCancellationDialogOpen,
        openConfirmCancellationDialog,
        closeConfirmCancellationDialog,
        cancelLicense,
    } = useCancelLicense(subscriptionId, onCancelled, onError);

    return (
        <>
            <Box display="flex" justifyContent="flex-end" width="100%" marginTop={2}>
                <Button
                    variant="text"
                    color="error"
                    size="small"
                    onClick={openConfirmCancellationDialog}
                    disabled={isCancelling}
                    sx={{
                        textTransform: 'none',
                        fontWeight: 600,
                        fontSize: '13px',
                        '&.MuiButton-root': {
                            px: '4px',
                        },
                    }}
                >
                    {isCancelling ? 'Cancelling...' : 'Cancel Subscription'}
                </Button>
            </Box>
            <CancelSubscriptionDialog
                isOpen={isConfirmCancellationDialogOpen}
                subscriptionName={subscriptionName}
                onClose={closeConfirmCancellationDialog}
                onConfirmCancel={cancelLicense}
            />
        </>
    );
}
